import React from "react";
import { Tooltip } from "antd";
import type { TooltipProps } from "antd";
import TrebbleConfigProvider from "./ConfigProvider";
import useDefaultTrebbleAntDTokenConfig from "../helper/useDefaultTrebbleAntDTokenConfig";

// Use intersection type for the props
type TrebbleTooltipProps = TooltipProps & {
  useEditorTheme?: boolean;
};

const TrebbleTooltip = ({ useEditorTheme, ...restProps }: TrebbleTooltipProps) => {
  const themeConfig = useDefaultTrebbleAntDTokenConfig({ useEditorTheme });

  return (
    <TrebbleConfigProvider theme={themeConfig} useEditorTheme={useEditorTheme}>
      <Tooltip {...restProps} />
    </TrebbleConfigProvider>
  );
};

export default TrebbleTooltip; 